export default __webpack_public_path__ + "static/media/1360.e60d5f6a.png";